<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import SwiperTool from "@/components/swiperTool.vue";

import {
  getManufacturers,
  deleteServiceReport,
  exportReport,
  getAuditingDevice,
  getAuditingDeviceMeasurement,
  getAuditingReport,
  getAuditingDiagnosis, getAuditingService, auditingRating, getAuditingReportDetail, getAuditingDetail
} from "@/service";
import {formatDatetime} from "@/helpers/common";
import _ from 'lodash';
import {
  AUDITING_MEASUREMENT_UNIT_MAP, 
  SERVICE_REPORT_TYPE, 
  SERVICE_REPORT_TYPE_TXT, WO_OODT_ASSETS,
  AUDITING_ORDER_REPORT_STAUTS,
} from '@/config/common';
import tableLoading from "@/views/widgets/table-loading.vue";
import {alertComfirm, alertError, successMsg} from "@/helpers/swal";
import i18n from "@/i18n";
import moment from "moment"
import {  htmlPdf } from "@/utils/htmlToPdf";
import { createADownload, previewPdf } from '@/utils/common'

// 引入方法
const serviceTypeOptions = [
  { label: i18n.global.t('page.allType'), value: '' },
  ...SERVICE_REPORT_TYPE
]


export default {
  props: {
    auditingAssignList:{
      type: Object,
      default() {
        return {}
      }
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    woId: {
      type: [Number, String],
      default: 0
    },
    // 工单信息
    woInfo: {
      type: Object,
      default: () => {}
    },
    editType: {
        type: Boolean,
        default () {
            return false
        }
    },
  },
  data() {
    return {
      serviceTypeOptions,
      SERVICE_REPORT_TYPE_TXT,
      AUDITING_ORDER_REPORT_STAUTS,
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      config: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      date2: null,
      tableHeaders: [
        {
          name: 'number',
          label: this.$t('page.report_number'),//'报告编号',
          visible: true
        },
        {
          name: 'customer_txt',
          label:this.$t('page.report_number'),//'客户名称',
          visible: true
        },
        {
          name: 'contact_name',
          label: this.$t('page.contact_person'),//'联系人',
          visible: true
        },
        {
          name: 'contact_number',
          label: this.$t('page.contact_phone'),//'联系电话',
          visible: true
        },
        {
          name: 'service_company_txt',
          label: this.$t('维保服务商'),//'维保服务商',
          visible: true
        },
        {
          name: 'owner_engineer_txt',
          label: this.$t('page.auditing.sales_service_engineer'),//'销售服务工程师',
          visible: true
        },
        {
          name: 'status',
          label: this.$t('page.status'),//'状态',
          visible: true
        },
        {
          name: 'created_at',
          label: this.$t('page.service-time'),//'服务时间',
          visible: true
        },
        {
          name: 'visit_remark',
          label: this.$t('page.return-visit-remarks'),//'回访备注',
          visible: localStorage.getItem("user")&&JSON.parse(localStorage.getItem("user")).user_type==='manufacturer'
        },
        {
          name: 'rating_score',
          label: this.$t('page.service-ratings'),// '服务评分',
          visible: true
        },
      ],
      showAllColumns: [],
      tableLoading: false,
      tableLoaded: false,
      dataList: [],
      count: 0,
      filters: {
        page: 1,
        page_size: 2,
      },
      filter_value: {
        keyword: '',
        created_at: '',
        type: null,
      },
      reportModal:false,
      measuringPointTableData:[],
      pointTypeList:[
        "入口压力",
        "出口压力",
        "工作液温度",
        "电流",
        "电机轴承温度",
        "电机轴承振动",
        "泵驱动端轴承温度",
        "泵非驱动端轴承温度",
        "泵驱动端轴承水平振动",
        "泵驱动端轴承垂直振动",
        "泵非驱动端轴承水平振动",
        "泵非驱动端轴承垂直振动",
        "泵非驱动端轴承轴向振动"
      ],
      unitList:AUDITING_MEASUREMENT_UNIT_MAP,
      equipmentInfo:[],
      checkTabValDec:'',
      changeDetail:{},
      tableData:[
        {
          id: 1,
          date: 'CF732',
          name: '2BW4',
          address: 'No. 189, Grove St, Los Angeles',
          users: ['1','2','3'],
        },
        {
          id: 2,
          date: 'CF732',
          name: '2BE1 203',
          address: 'No. 189, Grove St, Los Angeles',
          users: ['1','2','3'],
        },
        {
          id: 3,
          date: 'CF732',
          name: '2BE1 203',
          address: 'No. 189, Grove St, Los Angeles',
          users: ['1','2','3'],
        },
        {
          id: 4,
          date: 'CF732',
          name: '2BE1 203',
          address: 'No. 189, Grove St, Los Angeles',
          users: ['1','2','3'],
        },
      ],
      equipments:[],
      tableHeadersBusiness: [
        {
          name: "number",
          label: "商机类型",
          visible: true,
        },
        {
          name: "type1",
          label: "预估金额",
          visible: true,
        },
        {
          name: "type2",
          label: "成单可行性",
          visible: true,
        },
        {
          name: "type3",
          label: "设备",
          visible: true,
        },
        {
          name: "type4",
          label: "备注 ",
          visible: true,
        }
      ],
      rateValue:0,
      content:'',
      returnContent:'',
      signature:{
        url:'',
        created_at:''
      },

      tableHeadersjigai:[
        {
          name: "devices",
          label: "设备",
          visible: true,
        },
        {
          name: "fault_name",
          label: "故障表现",
          visible: true,
        },
        {
          name: "remark",
          label: "备注",
          visible: true,
        }
      ],
     tableHeadersAbnormal: [
       {
         name: "number",
         label: "设备",
         visible: true,
       },
       {
         name: "type",
         label: "可能异常测点",
         visible: true,
       },
       {
         name: "priority",
         label: "故障表现",
         visible: true,
       },
       {
         name: "device_name",
         label: "初步分析原因",
         visible: true,
       },
       {
         name: "device_root_sn",
         label: "建议解决方案",
         visible: true,
       },
       {
         name: "warranty_status",
         label: "附件",
         visible: false,
       },
     ],
      tableHeadersNormal: [
        {
          name: "name",
          label: "设备",
          visible: true,
        },
        {
          name: "remark",
          label: "备注",
          visible: true,
        },
        {
          name:"attachment",
          label: "附件",
          visible: false,
        }
    ],
      normalList:[],
      faultList:[],
      maintenanceSuggestionTable:[],
      tableHeadersMaintenanceSuggestion: [
        {
          name: "number",
          label: "设备",
          visible: true,
        },
        {
          name: "type",
          label: "故障表现",
          visible: true,
        },
        {
          name: "types",
          label: "维保建议",
          visible: true,
        }
      ],
      sparePartsList:[],
      tableHeadersSpareParts: [
        {
          name: "number",
          label: "设备",
          visible: true,
        },
        {
          name: "type",
          label: "故障表现",
          visible: true,
        },
        {
          name: "attachmentLevel",
          label: "规格",
          visible: true,
        },
        {
          name: "attachmentNum",
          label: "用量",
          visible: true,
        },
        {
          name: "types",
          label: "配件建议",
          visible: true,
        }
      ],
      upgradingList:[],
      careList:[],
      weixiuList:[],
      tihuanList:[],
      tableHeadersUpgrading: [
        {
          name: "devices",
          label: "设备",
          visible: true,
        },
        {
          name: "fault_name",
          label: "故障表现",
          visible: true,
        },
        {
          name: "remark",
          label: "备注",
          visible: true,
        }
      ],
      reportDetail:[],
      tabOptions:[],

      // 设备制造商信息
      sbzzsCompanyInfo: {}
    };
  },
  components: {
    Multiselect,
    tableLoading,
    SwiperTool
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    // 是否是客户 - 客户才能操作
    canOperate(){
       // this.user.user_type 类型如下: 
      // manufacturer:设备制造商，nash 
      // service_company：代理商
      // customer：终端客户
      // if(this.permission.includes('auditing.role.technical') || this.permission.includes('auditing.role.sale')) return false // 销售人员和技术人员都不能操作
      // return this.user.user_type === 'customer'
      return false; /* 评价由手机端操作 */
    },
    permission(){
      return JSON.parse(localStorage.getItem("permission"));
    },
  },
  watch: {
    woInfo: {
      immediate: true,
      deep: true,
      handler() {
        this._getList()

      }
    }
  },
  mounted() {
    this.getCompanyInfo()
    this._getFirstPage()
  },

  methods: {
    logoImage(){
      const baseURL = _.trimEnd(_.trim(WO_OODT_ASSETS, '"'), "/")
      return `${baseURL}/oodt-assets/auditing/nash.svg`
    },
    // 设备制造商信息
    getCompanyInfo(){
      getManufacturers({}).then(res=>{
        let info = {}
        try{
          info = res.payload.results[0] || {}
        }catch(e){
          console.error(e)
        }
        this.sbzzsCompanyInfo = info
      })
    },
    //服务建议
    getAuditingServices(){
      let params={
        order_id:this.$route.params.id,
        detail_id:this.checkTabValDec
      }
      getAuditingService(params).then(res=>{
        if(res.payload&&res.payload.data){
          this.maintenanceSuggestionTable=res.payload.data['1']&&res.payload.data['1']||[]
          this.sparePartsList=res.payload.data['2']&&res.payload.data['2']||[]
          this.upgradingList=res.payload.data['3']&&res.payload.data['3']||[]
          this.careList=res.payload.data['4']&&res.payload.data['4']||[]
          this.weixiuList=res.payload.data['5']&&res.payload.data['5']||[]
          this.tihuanList=res.payload.data['6']&&res.payload.data['6']||[]
        }
      })
    },
    //诊断记录
    getAuditingDiagnosis(){
      let params={
        order_id:this.$route.params.id,
        detail_id:this.checkTabValDec
      }
      getAuditingDiagnosis(params).then(res=>{
        this.normalList = res.payload.normal
        this.faultList = res.payload.fault
      })
    },
    //设备列表
    getAuditingDevices(){
      let params={
        order:this.$route.params.id,
        detail:this.checkTabValDec,
        page_size:1000
      }
      getAuditingDevice(params).then(res=>{
        console.log(res)
        if(res&&res.payload&&res.payload.results){
          let result = []
          res.payload.results.map(item=>{
            if(item.product_type == 1){
              result.push(item)
            }
          })
          this.equipmentInfo = result
          this.getAuditingDeviceMeasurements()
          this.getAuditingDiagnosis()
          this.getAuditingServices()
        }
      })
    },
    //测点列表
    getAuditingDeviceMeasurements(){
      this.measuringPointTableData=[]
      let params={
        detail_id:this.checkTabValDec
      }
      getAuditingDeviceMeasurement(params).then(res=>{
        // this.equipmentInfo.map(item=>{
        //   if(item.detail==this.checkTabValDec){
        //     this.measuringPointTableData.push({
        //       device_name:item.device_name,
        //       location:item.device_attributes&&item.device_attributes.device_address,
        //       device: {
        //         "odid":item.id,
        //         "did": item.device&&item.device,
        //         "data": {
        //           "入口压力": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'kpa'
        //           },
        //           "出口压力": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'kpa'

        //           },
        //           "工作液温度": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'°C'

        //           },

        //           "电流": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'A'

        //           },
        //           "电机轴承温度": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'°C'

        //           },
        //           "电机轴承振动": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'mm/s'

        //           },
        //           "泵驱动端轴承温度": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'°C'

        //           },
        //           "泵非驱动端轴承温度": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'°C'

        //           },
        //           "泵驱动端轴承水平振动": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'mm/s'
        //           },
        //           "泵驱动端轴承垂直振动": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'mm/s'

        //           },
        //           "泵非驱动端轴承水平振动": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'mm/s'

        //           },
        //           "泵非驱动端轴承垂直振动": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'mm/s'

        //           },
        //           "泵非驱动端轴承轴向振动": {
        //             "v": 0,
        //             "s": "1",
        //             "u":'mm/s'

        //           }
        //         }
        //       },
        //     })
        //   }
        // })
        this.$nextTick(()=>{
          if(res.payload.length>0){
            //测点列表--解析设备名称
            let reslut = []
            _.cloneDeep(res.payload).map(item=>{
              let info = this.equipmentInfo.find(item_=>item_.id == item.odid)
              if(info){
                reslut.push({
                  device_name:info.device_name,
                  location:info.device_attributes&&info.device_attributes.device_address,
                  device: item
                })
              }else{
                reslut.push({
                  device_name:"",
                  location:"",
                  device: item
                })
              }
              // this.measuringPointTableData.map(a=>{
              //   if(a.device.odid==item.odid){
              //     a.device=item
              //   }
              // })
            })

            this.measuringPointTableData = reslut
          }
        })
      })
    },
    moment,
    formatDatetime,
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.count;
      let numberOfPages = Math.ceil(this.count / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // 新建服务报告
    add() {
      this.$refs.addServiceReport.open()
    },
    // 报告导出
    download(id) {
      exportReport(id).then(res => {
        window.open('/service-report-download/' + res.payload.request_id, '_blank', 'noreferrer')
      }).catch(err => {
        console.log(err)
        alertError(this.$t('base.prompt'), this.$t('base.an-error-occurred'))
      })
    },
    // 删除报告
    del(id) {
      alertComfirm().then(res => {
        if (res) {
          deleteServiceReport(id).then(() => {
            successMsg(this.$t('base.delete_success'))
            this._getList()
          }).catch(err => {
            console.log(err)
            alertError(this.$t('base.prompt'), this.$t('base.an-error-occurred'))
          })
        }
      })
    },
    // 筛选
    doFilter () {
      this.orders = []
      const search = {
        keyword: null,
        created_at_before: null,
        created_at_after: null,
        type: null
      }
      if (this.filter_value.keyword) {
        search['keyword'] = this.filter_value.keyword
      }
      if (this.filter_value.created_at) {
        search['created_at_before'] = this.filter_value.created_at
        search['created_at_after'] = this.filter_value.created_at
      }
      if (this.filter_value.type) {
        search['type'] = this.filter_value.type
      }
      this.filters = _.assign(this.filters, search)
      this._getFirstPage()
    },
    // 重置
    resetSearch() {
      this.filter_value.created_at = null
      this.filter_value.type = null
      this.filter_value.keyword = null
      this.doFilter()
    },
    // 翻页
    pageChange(val) {
      this.filters.page = val
      this._getList()
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.filters.page_size = val
      this._getFirstPage()
    },
    // 获取数据
    _getFirstPage() {
      this.filters.page = 1;
      this._getList()
    },
    _getList() {
      let params={
        order:this.$route.params.id
      }
      this.tableLoading = true
      this.tableLoaded = false
      getAuditingReport(params).then(res => {
        this.tableLoading = false
        this.tableLoaded = true
        this.dataList = res.payload.results
        this.dataList.map(item => {
          item.preview_url = false
          if (item.attachment && item.attachment.length > 0) {
            for (var i in item.attachment) {
              let _item = item.attachment[i]
              if (_item.content_type == "application/pdf" || _item.content_type.indexOf("image") != -1) {
                item.preview_url = _item.url
                break
              }
            }
          }
          return item
        })

        this.count = res.payload.count
        this.setPages()
      }).catch(err => {
        console.log(err)
      })
    },
     handleExport(){
      try{
        // 确保页面渲染完毕
        setTimeout(() => {
          htmlPdf.getPdf("服务报告",
              document.querySelector("#printJS-form")
          );
        }, 1000)
      }catch(e){
        throw new Error(e)
      }
    },
    fileDownload(downloadUrl) {
      let aLink = document.createElement("a");
      aLink.style.display = "none";
      // 以防base64过长导致下载失败，所以将base64转成blob格式
      aLink.href = URL.createObjectURL(this.dataURIToBlob(downloadUrl));
      aLink.download = "img.png";
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    },
    // base64转blob方法
   dataURIToBlob (dataURI) {
      let binStr = atob(dataURI.split(",")[1]),
          len = binStr.length,
          arr = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      return new Blob([arr]);
    },
    viewPdf(content) {
      console.log("content",content);
      const blob = this.parseBlob(content);
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob);
      } else {
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);//打开ppf文件
        window.URL.revokeObjectURL(fileURL);
      }
    },
    parseBlob(base64) {
      var arr = base64.split(",");
      // var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      for (var i = 0; i < n; i++) {
        u8arr[i] = bstr.charCodeAt(i);
      }

  // var file2 = new File(
      //     [a],
      //     "Waste Transfer Note" +
      //     _.get(this, ["po_info", "order", "number"]) +
      //     ".pdf",
      //     { type: "application/pdf" }
      // );
      return new Blob([u8arr], {type: "application/pdf"});
    },
    detailClick(item){
      this.checkTabValDec=item.detail;
      this.getAuditingDevices();
      getAuditingReportDetail(item.id).then(res=>{
        this.reportDetail = res.payload
        this.rateValue=this.reportDetail.rating_score&&this.reportDetail.rating_score||0
        this.content=this.reportDetail.comment&&this.reportDetail.comment||''
        this.returnContent=this.reportDetail.visit_remark&&this.reportDetail.visit_remark||''
        this.signature = this.reportDetail.signature||{
          url:'',
          created_at:''
        }
        this.reportModal=!this.reportModal;
        this.getAuditingDetails()
      })
    },
setAuditingRating(){
      if(this.rateValue.length===0||this.content.length===0){
        alertError('请填写服务评价')
        return
      }
      let params={
        report_id:this.reportDetail.id,
        score:this.rateValue,
        content:this.content,
        signature:this.reportDetail.signature

      }
      auditingRating(params).then(res=>{
        console.log(res)
        this.reportModal=!this.reportModal;
        successMsg('保存服务评价成功，服务报告已完成!')
          this._getList()
      })
},
    //联系人列表
    getAuditingDetails(){
      this.tabOptions=[]
      getAuditingDetail({ order:this.$route.params.id}).then(ress=>{
        if(ress.payload.results&&ress.payload.results.length>0){
          this.tabOptions=ress.payload.results.filter(item=>{return item.id===this.reportDetail.detail})

        }

      })
    },
    downLoadFile (url){
      // let fileName = url.slice(url.lastIndexOf('/') + 1); // 这里是通过从后端获取到的 url  地址中截出来原本的文件名
      if(url){
        fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.target = "_blank"
              link.click()
              // 下载文件的名称及文件类型后缀
              // link.download = fileName;
              // document.body.appendChild(link);
              // link.click();
              // //在资源下载完成后 清除 占用的缓存资源
              // window.URL.revokeObjectURL(link.href);
              // document.body.removeChild(link);
            });
      }

    },
    // 下载
    downLoadFileNew(link){
      if(!link) return alertError('pdf地址不存在')
      createADownload(link,'download.pdf')
    },
    localPreviewPdf(link){
      if(!link) return alertError('pdf地址不存在')
      previewPdf(link)
    }
  },
}
</script>

<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card no-body id="orderList">
          <b-card-header class="border-0">
            <div style="color: #212529;font-size: 16px;font-weight: 500;">{{ $t('服务报告') }}</div>
          </b-card-header>
          <b-card-body v-if="showSearch" class="border border-dashed border-end-0 border-start-0 mb-3">
            <b-form>
              <b-row class="g-3">
                <b-col xxl="4">
                  <div class="search-box">
                    <input type="text" class="form-control search" v-model="filter_value.keyword"
                           :placeholder="user&&user.user_type==='customer'?$t('page.reportNumberCustomerNameAgentDeviceSerial'):$t('page.reportNumberCustomerNameAgentDeviceSerialNumber')" />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </b-col>
                <b-col xxl="3">
                  <div>
                    <flat-pickr :placeholder="$t('page.selectCreationTime')" v-model="filter_value.created_at" :config="config" class="form-control flatpickr-input"></flat-pickr>
                  </div>
                </b-col>
                <b-col xxl="3">
                  <div class="input-light">
                    <Multiselect class="form-control" :placeholder="$t('page.pleaseSelectType')" v-model="filter_value.type" :close-on-select="true" :searchable="false" :create-option="false" :options="serviceTypeOptions" :can-clear="false" />
                  </div>
                </b-col>
                <b-col xxl="2"  class="d-flex justify-content-end align-items-end">
                  <b-button type="button" variant="primary" class="me-2" @click="doFilter">
                    <i class="ri-search-line me-1 align-bottom"></i>
                    {{ $t('page.filter') }}
                  </b-button>
                  <b-button
                      type="button"
                      variant="info"
                      @click="resetSearch"
                  >
                    <i class="ri-restart-line me-1 align-bottom"></i>
                    {{ $t('page.reset') }}
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
          <b-card-body class="pt-0">
            <div>
              <div class="table-responsive mb-1">
                <table class="table table-nowrap align-middle" id="orderTable">
                  <thead class="text-muted table-light">
                  <tr class="text-uppercase">
                    <template v-for="(item, index) in tableHeaders" :key="index">
                      <th style="width: 200px" v-if="item.name==='reporter_txt'||item.name==='reporter_time'">{{$t(item.label)}}</th>
                      <th v-else v-show="item.visible&&(user&&user.user_type!=='customer'||(user&&user.user_type==='customer'&&(item.label!==$t('page.customer')||item.label===$t('page.user.department'))))">{{ $t(item.label) }}</th>
                    </template>
                    <th>
                      {{ $t('page.operation') }}
                    </th>
                  </tr>
                  </thead>
                  <tbody class="list form-check-all">
                  <tr v-for="(item, index) in dataList" :key="index">
                    <template v-for="(titleItem, titleIdx) in tableHeaders" :key="titleIdx">
                      <td v-if="titleItem.label==$t('page.status')&&item[titleItem.name]">
                        <div  style="border-radius: 4px;background: #6691E7;width: fit-content;padding:0 5px;height: 20px;color:#ffffff;text-align: center;"   :style="{background:AUDITING_ORDER_REPORT_STAUTS[item[titleItem.name]].color}">
                          {{AUDITING_ORDER_REPORT_STAUTS[item[titleItem.name]].txt}}
                        </div>
                      </td>
                      <td v-else-if="titleItem.label==$t('page.service-ratings')">
                        <el-rate
                            v-if="item[titleItem.name]"
                            v-model="item[titleItem.name]"
                            show-score
                            text-color="#ff9900"
                            disabled
                        />
                      </td>
                      <td v-else-if="titleItem.label==$t('page.service-time')">
                        {{moment(item[titleItem.name]).format("YYYY-MM-DD")}}
                      </td>

                      <td v-else v-show="titleItem.visible">
                        <span>{{ item[titleItem.name] }}</span>
                      </td>
                    </template>
                    <td>
                      <i @click="detailClick(item)" class="ri-eye-fill fs-3 text-primary me-3"></i>
<!--                      <i @click="handleExport()" class="ri-download-2-fill fs-3 text-primary me-3"></i>-->
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table-loading :count="count" :table-loaded="tableLoaded" :table-loading="tableLoading"></table-loading>
              </div>
              <Pagination
                  v-if="tab_info_length"
                  v-model:page="page"
                  v-model:perPage="perPage"
                  :pages="pages"
                  :prePageOption="prePageOption"
                  :tab_info_length="tab_info_length"
                  @update:page="pageChange"
                  @update:perPage="pageSizeChange"
                  class="me-5 my-3"
              ></Pagination>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
        v-model="reportModal"
        hide-footer
        dialog-class="modal-dialog-centered"
        class="v-modal-custom"
        title=""
        centered
        size="fullscreen"
    >
      <div class="modal-body" style="background: #F3F6F9;">
        <div class="d-flex justify-content-between pdfRef">
          <div class="d-flex align-items-start">
            <div>
              <div style="text-align: justify-all;color: #212529;font-size: 40px;font-weight: 600;letter-spacing: 40px;">服务报告</div>
              <div style="color: #212529;font-size: 36px;font-weight: 400;letter-spacing: 3px;">Service  report</div>
            </div>
            <div style="color: #212529;font-size: 20px;font-weight: 400;">
              <div style="font-size: 24px;font-weight: 500;" class="mt-2">服务商名称：{{auditingAssignList.original&&auditingAssignList.original.company_name}}</div>
              <div class="mt-2">地址: {{ sbzzsCompanyInfo.address }}</div>
              <!-- <div class="mt-2">Tel: {{auditingAssignList.original&&auditingAssignList.original.company_tel}}</div> -->
              <div class="mt-2">Tel: {{ sbzzsCompanyInfo.tel }}</div>
              <div class="mt-2">Email: {{ sbzzsCompanyInfo.email }}</div>
            </div>
          </div>

          <div style="width: 350px;">
            <img 
              :src="`${logoImage()}`">
          </div>
        </div>
        <b-card class="report-class mt-4 pdfRef">
          <b-card-header style="background: #405189;color:#ffffff" class="fs-14 fw-bold d-flex justify-content-between">
            <div>
               <img style="width: 19px;height:19px" src="../components/reportimg/1.svg" alt="#"> 客户信息
            </div>
          </b-card-header>
          <b-card-body>
            <table class="table table-bordered table-nowrap table-border w-100">
              <tbody style="border-radius: 8px;">

              <tr>
                <td>
                  <div class="d-flex">
                    <div style="width:100px">客户名称</div>
                    <div style="margin-left:100px">{{ reportDetail.customer_txt }}</div>
                  </div>
                </td>
                <td>
                  <div class="d-flex">
                    <div style="width:100px">服务类型</div>
                    <div style="margin-left:100px">{{ woInfo.type_txt&&$t(woInfo.type_txt)||'-'  }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <!-- <td>
                  <div class="d-flex">
                    <div style="width:100px">KA客户等级</div>
                    <div style="margin-left:100px">{{ woInfo.ka_level }}</div>
                  </div>
                </td> -->
                <td>
                  <div class="d-flex">
                    <div style="width:100px">服务时间</div>
                    <div style="margin-left:100px">{{moment(reportDetail.created_at).format("YYYY-MM-DD")}}</div>
                  </div>
                </td>
                <td>
                  <div class="d-flex">
                    <div style="width:100px">销售服务工程师</div>
                    <div style="margin-left:100px">{{auditingAssignList.original&&auditingAssignList.original.owner_engineer.name}}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex">
                    <div style="width:100px">联系人</div>
                    <div style="margin-left:100px">{{ reportDetail.contact_name }}</div>
                  </div>
                </td>
                <td>
                  <div class="d-flex">
                    <div style="width:100px">技术服务工程师</div>
                    <div style="margin-left:100px">{{auditingAssignList.original&&auditingAssignList.original.technical_engineer.name}}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex">
                    <div style="width:100px">联系电话</div>
                    <div style="margin-left:100px">{{ reportDetail.contact_number }}</div>
                  </div>
                </td>
                <td>
                  <div v-if="woInfo.ka_level&&woInfo.ka_level=='C'" class="d-flex">
                    <div style="width:100px">授权服务工程师</div>
                    <div style="margin-left:100px">{{auditingAssignList.authorized&&auditingAssignList.authorized.engineer.name}}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex">
                    <div style="width:100px">地址</div>
                    <div style="margin-left:100px">{{ woInfo.customer_address }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex">
                    <div style="width:100px">备注</div>
                    <div style="margin-left:100px">{{ woInfo.remark }}</div>
                  </div>
                </td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </b-card-body>
        </b-card>
        <b-card class="report-class pdfRef">
          <b-card-header style="background: #405189;color:#ffffff" class="fs-14 fw-bold d-flex justify-content-between">
            <div>
              <img style="width: 19px;height:19px" src="../components/reportimg/2.svg" alt="#"> 设备测点
            </div>
          </b-card-header>
          <b-card-body>
            <el-table
                :data="measuringPointTableData"
                style="width: 100%; margin-bottom: 20px"
                row-key="id"
                border
            >
              <el-table-column prop="device_name" label="设备名称"/>
              <el-table-column prop="location" label="设备位号" />
              <el-table-column v-for="(a,index) in pointTypeList" :key="a+index">
                <template #header>
                  <div class="text-center">{{a}}</div>
                  <div class="text-center">({{unitList[a]}})</div>
                </template>
                <template #default="scope">
                  <div :style="{color:{'1':'#212529','2':'#F7B84B','3':'#ED5E5E',height:'35px'}[scope.row.device.data[a]['s']]}">{{scope.row.device.data[a]['v']}}</div>
                </template>
              </el-table-column>
            </el-table>
          </b-card-body>
        </b-card>
        <b-card class="report-class pdfRef">
          <b-card-header style="background: #405189;color:#ffffff" class="fs-14 fw-bold d-flex justify-content-between">
            <div>
              <img style="width: 19px;height:19px" src="../components/reportimg/3.svg" alt="#"> 诊断记录
            </div>
          </b-card-header>
          <b-card-body>
            <div class=" w-100 text-center"  style="color:#909399;font-size: 14px;" v-if="faultList.length === 0&&normalList.length === 0">
              {{ $t('base.no-data') }}
            </div>
            <div v-if="faultList.length !== 0" class="d-flex align-items-center mb-4">
              <div><img src="../components/reportimg/icon.svg"  alt="#"></div>
              <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">异常设备</div>
            </div>
            <div
                v-if="faultList.length !== 0"
                :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]"
            > <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <!--                      <th scope="col" style="width: 25px">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <template
                    v-for="(item, index) in tableHeadersAbnormal"
                    :key="index"
                >
                  <th v-show="item.visible">{{ item.label }}</th>
                </template>
                <th v-if="editType">操作</th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
              <tr>
                <td colspan="100" class="text-center"  style="color:#909399;font-size: 14px;" v-if="faultList.length === 0">
                  {{ $t('base.no-data') }}
                </td>
              </tr>
              <tr  v-for="(a,index) in faultList" :key="index+'guzhang'">
                <td v-show="tableHeadersAbnormal[0].visible" :rowspan="1">
                  <div v-for="b in a.devices" :key="b.name">
                    {{b.name&&b.name||''}}
                  </div>
                </td>
                <td v-show="tableHeadersAbnormal[1].visible" :rowspan="1">
                  <div v-for="b in a.devices" :key="b.name">
                    <div v-for="c in b.measurement&&b.measurement" :key="c">
                      {{c}}
                    </div>
                  </div>
                </td>
                <td v-show="tableHeadersAbnormal[2].visible" :rowspan="1">
                  <div v-for="b in a.diagnosis" :key="b.fault_name">
                    {{b.fault_name}}
                  </div>
                </td>
                <td v-show="tableHeadersAbnormal[3].visible" :rowspan="1">
                  <div v-for="b in a.diagnosis" :key="b.name">
                    <div v-for="c in b.fault_list" :key="c">
                      {{c.fault_reason}}
                    </div>
                  </div>
                </td>
                <td v-show="tableHeadersAbnormal[4].visible" :rowspan="1">
                  <div v-for="b in a.diagnosis" :key="b.name">
                    <div v-for="c in b.fault_list" :key="c">
                      {{c.solution}}
                    </div>
                  </div>
                </td>
                <td v-show="tableHeadersAbnormal[5].visible" :rowspan="1">
                  <div v-for="b in a.diagnosis" :key="b.name">
                    <SwiperTool
                        :nextfalse="false"
                        :swiperInfo="{
                                type: 'document',
                                page: 'assetform',
                                spaceBetween: 10,
                                slidesPerView: 15,
                                actionsClass: [
                                  { name: 'ri-eye-fill', action: 'view' },
                                  { name: 'ri-download-2-fill', action: 'download' },
                                ],
                              }"
                        :list="b.attachment&&b.attachment"
                    >
                    </SwiperTool>
                  </div>

                </td>
                <td v-if="editType">
                  <el-popconfirm
                      confirm-button-text="确定"
                      cancel-button-text="取消"
                      hide-icon
                      title="是否删除该设备?"
                      @confirm="deleteDiagnosticPoint(a)"
                  >
                    <template #reference>
                      <i class="ri-delete-bin-fill cursor-pointer"></i>
                    </template>
                  </el-popconfirm>
                </td>
              </tr>
              </tbody>
            </table>
            </div>
            <div v-if="normalList.length !== 0" class="d-flex align-items-center mb-4">
              <div><img src="../components/reportimg/icon.svg"  alt="#"></div>
              <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">正常设备</div>
            </div>
            <div
                v-if="normalList.length !== 0"
                :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]"
            ><table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <!--                      <th scope="col" style="width: 25px">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <template
                    v-for="(item, index) in tableHeadersNormal"
                    :key="index"
                >
                  <th v-show="item.visible">{{ item.label }}</th>
                </template>
                <th v-if="editType">操作</th>

              </tr>
              </thead>
              <tbody class="list form-check-all">
              <tr>
                <td colspan="100" class="text-center"  style="color:#909399;font-size: 14px;" v-if="normalList.length === 0">
                  {{ $t('base.no-data') }}
                </td>
              </tr>
              <tr v-for="(item, index) in normalList" :key="index">
                <!--                      <th scope="row">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <td>
                  <div v-for="a in item.data" :key="a.device_name">{{ a.device_name }}</div>
                </td>
                <td>
                  <div v-for="a in item.data" :key="a.device_name+'1'">{{ a.remark }}</div>
                </td>
                <td>
                  <SwiperTool
                      :nextfalse="false"
                      :swiperInfo="{
                              type: 'document',
                              page: 'assetform',
                              spaceBetween: 10,
                              slidesPerView: 15,
                              actionsClass: [
                                { name: 'ri-eye-fill', action: 'view' },
                                { name: 'ri-download-2-fill', action: 'download' },
                              ],
                            }"
                      :list="item.attachment&&item.attachment"
                  >
                  </SwiperTool>
                </td>

                <td v-if="editType">
                  <el-popconfirm
                      confirm-button-text="确定"
                      cancel-button-text="取消"
                      hide-icon
                      title="是否删除该设备?"
                      @confirm="deleteDiagnosticPoint(item)"
                  >
                    <template #reference>
                      <i class="ri-delete-bin-fill cursor-pointer"></i>
                    </template>
                  </el-popconfirm>
                </td>
              </tr>
              </tbody>
            </table>
            </div>

          </b-card-body>
        </b-card>
        <b-card class="report-class pdfRef">
          <b-card-header style="background: #405189;color:#ffffff" class="fs-14 fw-bold d-flex justify-content-between">
            <div>
              <img style="width: 19px;height:19px" src="../components/reportimg/4.svg" alt="#"> 服务建议
            </div>
          </b-card-header>
          <b-card-body>
            <div v-if="maintenanceSuggestionTable.length>0" class="d-flex align-items-center mb-4">
              <div><img src="../components/reportimg/icon.svg"  alt="#"></div>
              <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">保养</div>
            </div>
            <div
                v-show="maintenanceSuggestionTable.length>0"
                :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]"
            > <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <!--                      <th scope="col" style="width: 25px">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <template
                    v-for="(item, index) in tableHeadersMaintenanceSuggestion"
                    :key="index"
                >
                  <th v-show="item.visible">{{ item.label }}</th>
                </template>
                <th v-if="editType">操作</th>

              </tr>
              </thead>
              <tbody class="list form-check-all">
              <tr v-for="item in maintenanceSuggestionTable" :key="item.fault_name">
                <td :rowspan="1">
                  <div v-for="a in item['devices']" :key="a">{{a}}</div>
                </td>
                <td :rowspan="1">{{item['fault_name']}}</td>
                <td :rowspan="1">
                  <div class="mt-1 mb-1" v-for="a in item['items']&&item['items']['suggestionList']" :key="a"><svg class="me-2" xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
                    <ellipse cx="4.51639" cy="4" rx="3.9866" ry="4" fill="#6691E7"/>
                  </svg>{{a}}</div>
                </td>
                <td v-if="editType">
                  <el-popconfirm
                      confirm-button-text="确定"
                      cancel-button-text="取消"
                      hide-icon
                      title="是否删除该设备?"
                      @confirm="deleteServicePoint(item)"
                  >
                    <template #reference>
                      <i class="ri-delete-bin-fill cursor-pointer"></i>
                    </template>
                  </el-popconfirm>
                </td>
              </tr>
              </tbody>
            </table>
            </div>
            <div v-if="sparePartsList.length>0" class="d-flex align-items-center mb-4">
              <div><img src="../components/reportimg/icon.svg"  alt="#"></div>
              <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">备件</div>
            </div>
            <div
                v-show="sparePartsList.length>0"
                :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]"
            > <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <!--                      <th scope="col" style="width: 25px">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <template
                    v-for="(item, index) in tableHeadersSpareParts"
                    :key="index"
                >
                  <th v-show="item.visible">{{ item.label }}</th>
                </template>
                <th v-if="editType">操作</th>

              </tr>
              </thead>
              <tbody class="list form-check-all">
              <tr v-for="(a,index) in sparePartsList" :key="a.fault_name+'spare'+index">
                <td  :rowspan="1">
                  <div v-for="b in a.devices" :key="b">{{b.split('$')[0]}}</div>
                </td>
                <td  :rowspan="1">
                  <div class="d-flex">
                    <div>{{a.fault_name}}</div>
                  </div>
                </td>
                <td  :rowspan="1">
                  <div class="d-flex">
                    <div class="ms-5">{{ {'3':'大修','2':'中修','1':'小修'}[a.items.attachmentLevel]}}</div>
                  </div>
                </td>
                <td  :rowspan="1">
                  <div class="d-flex">
                    <div class="ms-2">{{a.devices.length}}台*{{a.items.attachmentNum}}</div>
                  </div>
                </td>
                <td  :rowspan="1">
                  <table v-if="a.items.partsList&&a.items.partsList.length>0" class="table table-bordered table-striped table-nowrap w-100">
                    <thead class="text-muted table-light">
                    <tr class="text-uppercase">
                      <th scope="col">位号</th>
                      <th scope="col">台用量</th>
                      <th scope="col">名称</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="b in a.items.partsList" :key="b.id">
                      <th scope="row">{{b.location}}</th>
                      <td>{{b.quantity}}</td>
                      <td>
                        <el-popover
                            v-if="b.name==='维修包'"
                            placement="right"
                            :width="700"
                            trigger="click"
                            :teleported="false"
                        >
                          <template #reference>
                            <div style="text-decoration:underline;cursor: pointer;width:50px">{{ b.name }}</div>
                          </template>
                          <el-table height="300" :data="b.extra_info">
                            <el-table-column width="300"  property="desc" label="GDNC描述" />
                            <el-table-column  property="quantity" label="数量" />
                            <el-table-column  property="unit" label="单位" />
                            <el-table-column  property="location" label="位号" />
                          </el-table>
                        </el-popover>
                        <div v-else>
                          {{ b.name }}
                        </div>

                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
                <td v-if="editType">
                  <el-popconfirm
                      confirm-button-text="确定"
                      cancel-button-text="取消"
                      hide-icon
                      title="是否删除该设备?"
                      @confirm="deleteServicePoint(a)"
                  >
                    <template #reference>
                      <i class="ri-delete-bin-fill cursor-pointer"></i>
                    </template>
                  </el-popconfirm>
                </td>
              </tr>

              </tbody>
            </table>
            </div>
            <div v-if="upgradingList.length>0" class="d-flex align-items-center mb-4">
              <div><img src="../components/reportimg/icon.svg"  alt="#"></div>
              <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">技改</div>
            </div>
            <div
                v-show="upgradingList.length>0"
                :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]"
            ><table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <!--                      <th scope="col" style="width: 25px">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <template
                    v-for="(item, index) in tableHeadersjigai"
                    :key="index"
                >
                  <th v-show="item.visible">{{ item.label }}</th>
                </template>
                <th v-if="editType">操作</th>

              </tr>
              </thead>
              <tbody class="list form-check-all">
              <tr v-for="(item, index) in upgradingList" :key="index">
                <!--                      <th scope="row">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <template
                    v-for="(titleItem, titleIdx) in tableHeadersjigai"
                    :key="titleIdx"
                >
                  <td v-show="titleItem.visible">
                    <div v-if="titleItem.label==='设备'">
                      <div v-for="a in item[titleItem.name]" :key="a">{{a.split('$')[0]}}</div>
                    </div>
                    <div class="whiteSpaceNormal" v-else>{{ item[titleItem.name] }}</div>
                  </td>
                </template>
                <td v-if="editType">
                  <el-popconfirm
                      confirm-button-text="确定"
                      cancel-button-text="取消"
                      hide-icon
                      title="是否删除该设备?"
                      @confirm="deleteServicePoint(item)"
                  >
                    <template #reference>
                      <i class="ri-delete-bin-fill cursor-pointer"></i>
                    </template>
                  </el-popconfirm>
                </td>
              </tr>
              </tbody>
            </table>
            </div>
            <div v-if="weixiuList.length>0" class="d-flex align-items-center mb-4">
              <div><img src="../components/reportimg/icon.svg"  alt="#"></div>
              <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">维修</div>
            </div>
            <div
                v-show="weixiuList.length>0"
                :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]"
            ><table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <!--                      <th scope="col" style="width: 25px">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <template
                    v-for="(item, index) in tableHeadersUpgrading"
                    :key="index"
                >
                  <th v-show="item.visible">{{ item.label }}</th>
                </template>
                <th v-if="editType">操作</th>

              </tr>
              </thead>
              <tbody class="list form-check-all">
              <tr v-for="(item, index) in weixiuList" :key="index">
                <!--                      <th scope="row">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <template
                    v-for="(titleItem, titleIdx) in tableHeadersUpgrading"
                    :key="titleIdx"
                >
                  <td v-show="titleItem.visible">
                    <div v-if="titleItem.label==='设备'">
                      <div v-for="a in item.devices&&item.devices" :key="a">{{a}}</div>
                    </div>
                    <div v-if="titleItem.label==='故障表现'">
                      {{ item[titleItem.name] }}
                    </div>
                    <div class="whiteSpaceNormal" v-if="titleItem.label==='备注'">
                      {{ item.items&&item.items.desc }}
                    </div>
                  </td>
                </template>
                <td v-if="editType">
                  <el-popconfirm
                      confirm-button-text="确定"
                      cancel-button-text="取消"
                      hide-icon
                      title="是否删除该设备?"
                      @confirm="deleteServicePoint(item)"
                  >
                    <template #reference>
                      <i class="ri-delete-bin-fill cursor-pointer"></i>
                    </template>
                  </el-popconfirm>
                </td>
              </tr>
              </tbody>
            </table>
            </div>
            <div v-if="tihuanList.length>0" class="d-flex align-items-center mb-4">
              <div><img src="../components/reportimg/icon.svg"  alt="#"></div>
              <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">替换</div>
            </div>
            <div
                v-show="tihuanList.length>0"
                :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]"
            ><table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <!--                      <th scope="col" style="width: 25px">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <template
                    v-for="(item, index) in tableHeadersUpgrading"
                    :key="index"
                >
                  <th v-show="item.visible">{{ item.label }}</th>
                </template>
                <th v-if="editType">操作</th>

              </tr>
              </thead>
              <tbody class="list form-check-all">
              <tr v-for="(item, index) in tihuanList" :key="index">
                <!--                      <th scope="row">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <template
                    v-for="(titleItem, titleIdx) in tableHeadersUpgrading"
                    :key="titleIdx"
                >
                  <td v-show="titleItem.visible">
                    <div v-if="titleItem.label==='设备'">
                      <div v-for="a in item.devices&&item.devices" :key="a">{{a}}</div>
                    </div>
                    <div v-if="titleItem.label==='故障表现'">
                      {{ item[titleItem.name] }}
                    </div>
                    <div class="whiteSpaceNormal" v-if="titleItem.label==='备注'">
                      {{ item.items&&item.items.desc }}
                    </div>
                  </td>
                </template>
                <td v-if="editType">
                  <el-popconfirm
                      confirm-button-text="确定"
                      cancel-button-text="取消"
                      hide-icon
                      title="是否删除该设备?"
                      @confirm="deleteServicePoint(item)"
                  >
                    <template #reference>
                      <i class="ri-delete-bin-fill cursor-pointer"></i>
                    </template>
                  </el-popconfirm>
                </td>
              </tr>
              </tbody>
            </table>
            </div>
            <div v-if="careList.length>0" class="d-flex align-items-center mb-4">
              <div><img src="../components/reportimg/icon.svg"  alt="#"></div>
              <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">Care</div>
            </div>
            <div
                v-show="careList.length>0"
                :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]"
            ><table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <!--                      <th scope="col" style="width: 25px">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <template
                    v-for="(item, index) in tableHeadersUpgrading"
                    :key="index"
                >
                  <th v-show="item.visible">{{ item.label }}</th>
                </template>
                <th v-if="editType">操作</th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
              <tr v-for="(item, index) in careList" :key="index">
                <!--                      <th scope="row">-->
                <!--                        <div class="form-check">-->
                <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                <!--                        </div>-->
                <!--                      </th>-->
                <template
                    v-for="(titleItem, titleIdx) in tableHeadersUpgrading"
                    :key="titleIdx"
                >
                  <td v-show="titleItem.visible">
                    <div v-if="titleItem.label==='设备'">
                      <div v-for="a in item[titleItem.name]" :key="a">{{a}}</div>
                    </div>
                    <div v-if="titleItem.label==='故障表现'">
                      {{ item.fault_name }}
                    </div>
                    <div class="whiteSpaceNormal" v-if="titleItem.label==='备注'">
                      {{  item[titleItem.name] }}
                    </div>
                  </td>
                </template>
                <td v-if="editType">
                  <el-popconfirm
                      confirm-button-text="确定"
                      cancel-button-text="取消"
                      hide-icon
                      title="是否删除该设备?"
                      @confirm="deleteServicePoint(item)"
                  >
                    <template #reference>
                      <i class="ri-delete-bin-fill cursor-pointer"></i>
                    </template>
                  </el-popconfirm>
                </td>
              </tr>
              </tbody>
            </table>
            </div>
            <div class="w-100 text-center"  style="color:#909399;font-size: 14px;" v-if="maintenanceSuggestionTable.length===0&&sparePartsList.length===0&&upgradingList.length===0&&weixiuList.length===0&&tihuanList.length===0&&careList.length===0">
              {{ $t('base.no-data') }}
            </div>
          </b-card-body>
        </b-card>
        <b-card class="report-class pdfRef">
          <b-card-header style="background: #405189;color:#ffffff" class="fs-14 fw-bold d-flex justify-content-between">
            <div>
              <img style="width: 19px;height:19px" src="../components/reportimg/5.svg" alt="#"> 服务评价
            </div>
          </b-card-header>
          <b-card-body>
            <div class="d-flex align-items-center mt-4">
              <div style="width:100px">服务评分:</div>
              <div>
                <el-rate
                    v-model="rateValue"
                    show-score
                    text-color="#ff9900"
                />
              </div>
            </div>
            <div class="d-flex align-items-center mt-4">
              <div style="width:100px" >客户意见:</div>
              <input type="text" style="width:100%" class="blank" v-model="content">
            </div>
            <div v-if="user.user_type==='manufacturer'" class="d-flex align-items-center mt-4">
              <div style="width:100px" >回访备注:</div>
              <input disabled type="text" style="width:100%;background: transparent" class="blank" v-model="returnContent">
            </div>
            <div class="mt-4">
              <div style="width:100px">服务时间:</div>
              <table class="table table-bordered table-nowrap table-border w-100">
                <thead class="text-muted table-light">
                <tr class="text-uppercase">
                  <th>
                    出发日期
                  </th>
                  <th>
                    到达日期
                  </th>
                  <th>
                    离开日期
                  </th>
                </tr>
                </thead>
                <tbody style="border-radius: 8px;">
                <tr v-for="a in tabOptions" :key="a.id">
                  <td>
                    {{ a.departure_time }}
                  </td>
                  <td>
                    {{ a.arrival_time }}
                  </td>
                  <td>
                    {{ a.leave_time }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

          </b-card-body>
        </b-card>
        <div style="padding: 16px" class="d-flex justify-content-between pdfRef">
            <div>
              <div class="d-flex"><div style="width:70px">用户签字:</div><img style="width: 150px" :src="(signature&&signature.url)&&signature.url" alt="#"/></div>
              <div class="mt-2 d-flex"><div  style="width:70px">日期:</div><div>{{(signature&&signature.created_at)&&signature.created_at}}</div></div>
            </div>
          <div class="mt-2">

          </div>
          <div></div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <template v-if="canOperate">
          <button class="btn btn-light d-flex align-items-center" @click="reportModal=!reportModal"><span>取消</span></button>
          <button class="btn btn-primary d-flex align-items-center ms-2" @click="setAuditingRating"><span>确定</span></button>
        </template>

        <template v-if="reportDetail['pdf']&&reportDetail['pdf']['url']">
          <button class="btn btn-primary d-flex align-items-center ms-2" @click="localPreviewPdf((reportDetail['pdf']&&reportDetail['pdf']['url'])&&reportDetail['pdf']['url'])"><span>预览</span></button>
          <button class="btn btn-success d-flex align-items-center ms-2" @click="downLoadFileNew((reportDetail['pdf']&&reportDetail['pdf']['url'])&&reportDetail['pdf']['url'])"><span>下载</span></button>
        </template>

      </div>
    </b-modal>
  </div>
</template>
<style scoped>
.blank {
  border-bottom: 1px solid black;
  border-left-width: 0;
  border-top-width: 0;
  border-right-width: 0;
}

.blank:focus {
  border: none;
  border-bottom: 1px solid black !important;
  box-shadow: none;
  outline: none;
}

.blank:hover {
  border: none;
  border-bottom: 1px solid black !important;
  box-shadow: none;
}

.whiteSpaceNormal{
  white-space: normal;
}
</style>
